<div class="scroll-container">
  @if (!noPreview.includes(data.action.type)) {
  <ghs-action (click)="relative = !relative" [action]="data.action" [relative]="relative" [character]="data.character"
    [cardId]="data.cardId">
  </ghs-action>
  }
  <ghs-editor-action [(action)]="data.action" [character]="data.character" [cardId]="data.cardId"></ghs-editor-action>

  <a (click)="deleteAction()"><img class="ghs-icon" src="./assets/images/minus.svg">
    <span [ghs-label]="'editor.action.remove'"></span></a>
</div>